module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/2_e1e668d0704a59dc2b0ab08d509df2b5.png";